import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Accueil', path: '/' },
  { label: 'À propos', path: '/a-propos' },
  { label: 'Contact', path: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-12 flex items-center justify-between h-16 lg:h-20">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 cursor-pointer" aria-label="HASPICA – Accueil">
          <img
            src="https://public.readdy.ai/ai/img_res/91970f4e-b5c6-4f7a-ae01-b1bdc8335b8e.png"
            alt="Logo HASPICA"
            className="h-9 w-auto object-contain"
          />
          <span
            className={`font-bold text-lg tracking-widest transition-colors duration-300 ${
              scrolled ? 'text-[#0A0A0A]' : 'text-[#0A0A0A]'
            }`}
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            HASPICA
          </span>
        </Link>

        {/* Desktop Links */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium tracking-wide transition-colors duration-200 whitespace-nowrap cursor-pointer border-b-2 pb-0.5 ${
                location.pathname === link.path
                  ? 'text-[#0A0A0A] border-[#0A0A0A]'
                  : 'text-[#6B6B6B] border-transparent hover:text-[#0A0A0A] hover:border-[#0A0A0A]'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="ml-2 px-5 py-2 bg-[#0A0A0A] text-white text-sm font-medium rounded-md whitespace-nowrap cursor-pointer hover:bg-[#2A2A2A] transition-colors duration-200"
          >
            Nous contacter
          </Link>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menu"
        >
          <i className={`text-xl text-[#0A0A0A] ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium py-1 cursor-pointer ${
                location.pathname === link.path ? 'text-[#0A0A0A]' : 'text-[#6B6B6B]'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-2 px-5 py-2.5 bg-[#0A0A0A] text-white text-sm font-medium rounded-md text-center whitespace-nowrap cursor-pointer"
          >
            Nous contacter
          </Link>
        </div>
      )}
    </header>
  );
}
